const domain = "www.inductforwork.com.au";

export const environment = {
	production: true,
	version: "3.1.12-c0783e2f",
	v1AppURL: "../v1",
	siteURL: `https://${domain}`,
	certificateDesignerUrl: `https://${domain}/area/certificates`,
	apiURL: `https://${domain}/api/v2`,
	portalPath: "/portals/",
	cloudFrontContentURL: "https://content.ap-southeast-2.inductforwork.com",
	allowedDomains: [domain],
	disallowedRoutes: [],
	defaultCountryCode: "AU",
	defaultCountryTimeZone: "Australia/Melbourne",
	defaultCountryLocale: "en-AU",
	defaultCurrencySymbol: "$",
	stripeKey: "pk_live_NOcYPDhndnXTKDkpraH3ncr3",
	countryTaxString: "+GST",
	companyName: "Induct For Work",
	legalFalsificationOfDocuments:
		"Falsification of documents is a crime (CRIMES ACT 1958 - SECT 83A). Penalty: up to 10 years’ imprisonment.",
	googleWebFontsAPIKey: "AIzaSyAO2-8DwKEFpiKi53w7YCdtY6TeIJe0aBg",
	TaxBusinessNumberName: "ABN",
	deploymentPath: "/area/v3/",
	/*
   theme
   */
	defaultMenuType: "menu-default",
	subHiddenBreakpoint: 768,
	menuHiddenBreakpoint: 768,
	themeColorStorageKey: "vien-themecolor",
	isMultiColorActive: true,
	/*
  Color Options:
  'light.blueyale', 'light.blueolympic', 'light.bluenavy', 'light.greenmoss', 'light.greenlime', 'light.yellowgranola', 'light.greysteel', 'light.orangecarrot', 'light.redruby', 'light.purplemonster'
  'dark.blueyale', 'dark.blueolympic', 'dark.bluenavy', 'dark.greenmoss', 'dark.greenlime', 'dark.yellowgranola', 'dark.greysteel', 'dark.orangecarrot', 'dark.redruby', 'dark.purplemonster'
  */
	defaultColor: "light.orangecarrot",
	isDarkSwitchActive: true,
	defaultDirection: "ltr",
	themeRadiusStorageKey: "vien-themeradius",
	root: "/app",
	documentationUrl: `https://${domain}`,
	companyHelpPath: "/online-training/",
};
